import * as types from '../constants';

const initialState = {
  items: [],
  loading: true,
  error: null,
  showNotificationsDrawer: false,
  isNotificationPreference: false,
  userPreferences: {},
  webNotifications: []
};

function notifications(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ALERTS:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.GET_ALERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.alerts
      };

    case types.GET_ALERTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    case types.ADD_ALERT:
      return {
        ...state,
        loading: false,
        error: null
      };

    case types.TOGGLE_NOTIFICATIONS_DRAWER:
      return {
        ...state,
        showNotificationsDrawer: !state.showNotificationsDrawer
      };

    case types.TOGGLE_NOTIFICATIONS_PREFRENCE:
      if (!action.status) {
        return {
          ...state,
          isNotificationPreference: action.status
        };
      }
      return {
        ...state,
        isNotificationPreference: !state.isNotificationPreference
      };

    case types.UPDATE_USER_PREFERENCES:
      return {
        ...state,
        userPreferences: action.payload,
        loading: false
      };

    case types.UPDATE_WEB_NOTIFICATIONS:
      return {
        ...state,
        webNotifications: action.payload,
        loading: false
      };

    case types.LOADER:
      return {
        ...state,
        loading: true
      };

    case types.TURN_LOADER_OFF:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}

export { initialState, notifications };
